import React from "react";
import ChevronIcon from "@/common/images/icons/chevron.svg?react";
import { useAccordion } from "@/common/hooks/useAccordion";
import "./Accordion.scss";

interface IAccordion {
  title: React.ReactNode | string;
  children: React.ReactNode;
  initialExpanded?: boolean;
}

export const Accordion = ({ title, children, initialExpanded }: IAccordion) => {
  const { isExpanded, contentRef, toggleExpansion } = useAccordion(initialExpanded);

  return (
    <div className={`accordion ${isExpanded ? "accordionIsOpen" : ""}`}>
      <button className="accordionHeader" onClick={toggleExpansion} aria-expanded={isExpanded}>
        <p className="accordionTitle">{title}</p>
        <span className="accordionIcon"><ChevronIcon /></span>
      </button>
      <div ref={contentRef} className="accordionContent" role="region">
        <div>{children}</div>
      </div>
    </div>
  );
};
